import { createSelector } from '@reduxjs/toolkit';
import { selectTotalArea } from 'shared/selectors/jsonQuery';

export const selectTotalAreaAdvancedFilter = createSelector(selectTotalArea, range => ({
  value: { min: range?.gte ?? null, max: range?.lte ?? null },
}));
